// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "@/App";
import router from "@/router";
import "babel-polyfill";

import dateFormat from '@/common/date.js'
import request from '@/models/request.js'
import filters from "./common/filters.js"
import ElementUI from "element-ui";
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import VueTouch from 'vue-touch';
import MetaInfo from 'vue-meta-info';
import { Button, Toast, Field, Uploader, Overlay, Image, Lazyload, Notify, Popup, Picker, DatetimePicker, Area, List, Loading, ImagePreview } from 'vant'

import { getCookies, setCookies, removeCookies } from "@/common/auth";
import utils from "./common/util.js";

import * as directives from './directives' // global directives

import "element-ui/lib/theme-chalk/index.css";
import 'vant/lib/index.css'; 
import "@/assets/styles/main.scss";
import "@/assets/styles/style.css";
import "@/assets/styles/common.css";
import '@/vendors/rem.js';
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueAMap from 'vue-amap'; // 高德地图

// register global utility directives.
Object.keys(directives).forEach(key => Vue.directive(key, directives[key]))

// 注册全局过滤器
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))

Vue.prototype.$utils = utils
Vue.prototype.$http = request
Vue.prototype.$moment = moment
Vue.prototype.$momentTimezone = momentTimezone
Vue.prototype.$dateFormat = dateFormat

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.use(VueTouch, {
    name: 'v-touch'
});
Vue.use(MetaInfo);
Vue.use(Toast).use(Button).use(Field).use(Uploader).use(Overlay).use(Image).use(Lazyload).use(Notify).use(Popup).use(Picker).use(DatetimePicker).use(Area).use(List).use(Loading).use(ImagePreview);
Vue.use(VueAMap);

VueAMap.initAMapApiLoader({
    key: '51f0458afe2c1bd45a9a5d3652ee31ab',
    plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
    v: '1.4.15',
    uiVersion: '1.0.11'
});


Vue.mixin({
    data() {
        // 全局变量
        return {};
    },
    computed: {
        header() {
            let token = getCookies("token") || "";
            return {
                Authorization: "bearer " + token,
                // Accept: "application/vnd.caesar.v1+json",
            };
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            let token = getCookies("token");
            const whiteList = ["/login"];
            
            if (!token && whiteList.indexOf(to.path) == -1) {
                setTimeout(() => {
                    vm.$router.push({
                        path: "/login",
                    });
                }, 1000);
            }
        });
    },
    methods: {}
});

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router: router,
    template: "<App/>",
    components: {
        App
    }
});



// WEBPACK FOOTER //
// ./src/main.js